/*###########################################################################
// Components
//#########################################################################*/

/* Dynamic Components
//------------------*/

if (document.querySelector('.accordion')) {
  import('./_accordions')
}

if (document.querySelector('.copy-clipboard')) {
	import('./_copyClipboard')
}

if (document.querySelector('.cursor')) {
	import('./_cursor')
}

if (document.querySelector('.h-screen') || document.querySelector('.min-h-screen')) {
	import('./_hScreenCalc')
}

if (document.querySelector('.modal')) {
	import('./_modals')
}

if (document.querySelector('.responsive-video')) {
	import('./_responsiveVideo')
}

if (document.querySelector('.search-field')) {
	import('./_searchResults')
}

if (document.querySelector('.sliderGallery')) {
	import('./_sliderGallery')
}

if (document.querySelector('.sliderHomes')) {
	import('./_sliderHomes')
}

if (document.querySelector('.sliderImage')) {
	import('./_sliderImage')
}

if (document.querySelector('.sliderLogoBar')) {
	import('./_sliderLogoBar')
}

if (document.querySelector('.sliderQuotes')) {
	import('./_sliderQuotes')
}

if (document.querySelector('.sprigFilter')) {
	import('./_sprigFilter')
}

if (document.querySelector('.themeSelect')) {
	import('./_themeSelect')
}

/* Standard Components
//------------------*/

import './_browserDetect'
//import './_contactForm'
import './_forms'
import './_header'
import './_reveal'
import './_scrollTo'
